import { DEBRIDEMENT_CONFIG_VERSION } from "./debridementConfig";
import { visiblePrerequisites } from "./debridementRules";

export const buildDebridementPayload = ({ state, careSetting, ids }) => {
  const performed = state.isDebridementPerformed === "yes";

  const prerequisites = visiblePrerequisites(careSetting).map((p) => {
    const a = state.prerequisiteAnswers?.[p.key] || {};
    return {
      key: p.key,
      label: p.label,
      answer: a.value ?? null,
      value: a.value === "yes" ? a.selection : null,
      reasonCode: a.value === "no" ? a.reasonCode ?? null : null,
      reasonText: a.value === "no" ? a.reasonText ?? null : null,
    };
  });

  return {
    configVersion: DEBRIDEMENT_CONFIG_VERSION,
    careSetting,

    // Block 0
    isDebridementPerformed: state.isDebridementPerformed,
    notPerformedReason: performed ? null : state.notPerformedReason || null,

    // Block 1 — keyed collection, so a new prerequisite is a data change and
    prerequisites: performed ? prerequisites : [],

    // Block 2 — existing API field names preserved
    surgicalDebridementProcedure: performed ? state.surgicalDebridementProcedure || "" : "",
    nonExcisionalApproach: performed ? state.nonExcisionalApproach || "" : "",
    depthOfDebridement: performed ? state.depthOfDebridement || "" : "",
    necroticSubcutaneousTissue: performed ? state.necroticSubcutaneousTissue || [] : [],
    necroticTissue: performed ? state.necroticTissue || [] : [],
    notApplicable: [],
    instrumentsUsed: performed ? state.instrumentsUsed || [] : [],
    surfaceAreaOfNecroticSkinTissue: performed ? state.surfaceAreaOfNecroticSkinTissue || "" : "",
    surfaceAreaOfNecroticSubqTissue: performed ? state.surfaceAreaOfNecroticSubqTissue || "" : "",
    techniqueUsed: performed ? state.techniqueUsed || "" : "",
    honeyDressing: null,

    // Block 3
    painAfter: performed && state.painAfter !== "" ? Number(state.painAfter) : null,
    postDebridementBleedingAmount: performed ? state.postDebridementBleedingAmount || "" : "",
    stoppedBleedingContactPressure:
      performed && state.postDebridementBleedingAmount && state.postDebridementBleedingAmount !== "none"
        ? state.stoppedBleedingContactPressure || ""
        : "",

    ...ids,
  };
};
